import { render, staticRenderFns } from "./albertactionplan.vue?vue&type=template&id=1071d641&"
import script from "./albertactionplan.vue?vue&type=script&lang=js&"
export * from "./albertactionplan.vue?vue&type=script&lang=js&"
import style0 from "./albertactionplan.vue?vue&type=style&index=0&id=1071d641&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports